import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import * as Ariakit from '@ariakit/react'
import Button from 'components/Button'
import Column from 'components/Column'
import Margin from 'components/Margin'
import { Heading } from 'components/primitives'
import { CancelUlyDispatchForm } from './CancelUlyDispatchForm'
import { cancelDialogContext } from '../DispatchStatus'

function Wrapper({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  const dialog = Ariakit.useDialogContext()
  const { setSubmitted, setDispatchError } = cancelDialogContext.useCancelDialogContext()

  return (
    <Column>
      <Margin spacing="lg">{children}</Margin>
      <Button.Secondary
        onClick={() => {
          dialog?.hide()
          setSubmitted(false)
          setDispatchError(false)
        }}
      >
        {t('back')}
      </Button.Secondary>
    </Column>
  )
}

export function CancelUlyDispatchState({ caseId, serviceId }: { caseId: string; serviceId: string }) {
  const { t } = useTranslation()
  const { submitted, dispatchError } = cancelDialogContext.useCancelDialogContext()
  const dialog = Ariakit.useDialogContext()

  return (
    <Column>
      <Margin spacing="lg">
        <Heading as="h3" spacing="sm">
          {t('cancelDispatch.cancelService')}
        </Heading>
        {dispatchError ? (
          <Wrapper>{t('cancelDispatch.error')}</Wrapper>
        ) : submitted ? (
          <Wrapper>{t('cancelDispatch.success')}</Wrapper>
        ) : (
          <CancelUlyDispatchForm caseId={caseId} serviceId={serviceId} dialog={dialog} />
        )}
      </Margin>
    </Column>
  )
}

export default CancelUlyDispatchState
